
import "../Foundation/stylable/colors.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_177_0_FloatingNotification";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_177_0_FloatingNotification__root","icon":"wds_1_177_0_FloatingNotification__icon","text":"wds_1_177_0_FloatingNotification__text","textButton":"wds_1_177_0_FloatingNotification__textButton","button":"wds_1_177_0_FloatingNotification__button","gap":"wds_1_177_0_FloatingNotification__gap","close":"wds_1_177_0_FloatingNotification__close"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {}; 




